import dynamic from "next/dynamic";
import VerticalTagsWithImagesAssetConfig from "./vertical-tags-with-images-asset-config";
import VerticalTagsWithImagesAssetAdvancedConfig from "./vertical-tags-with-images-asset-advanced-config";
const VerticalTagsWithImagesAssetComponent = dynamic(()=>import("./vertical-tags-with-images-asset-component"));
export default {
    VerticalTagsWithImagesAssetComponent,
    VerticalTagsWithImagesAssetConfig,
    VerticalTagsWithImagesAssetAdvancedConfig
};
